import { useContext, useEffect, useRef, useState } from "react";
import { ConstantAPISContext } from "../../../context/ConstantAPISContext";
import { showToast } from "../../../helpers/ToastifyHelper";
import TableComponent from "../../../components/OB/TableComponent";
import SearchComponent from "../../../components/OB/SearchComponent";
import Select from '@mui/material/Select';
import { FormControl, InputLabel, MenuItem, CircularProgress } from "@mui/material";
import { Form, Formik } from "formik";
import ListHeaderComponent from "../../../components/OB/ListHeaderComponent";
import CevreTemizlikAPI from "../../../apis/OB/Get/CevreTemizlikAPI";

const CevreTemizlikTarifeleri: React.FC = () => {

    const columns = [
        { header: "Yılı", field: "yili", className: "text-center" },
        { header: "Grup", field: "grup", className: "text-center" },
        { header: "Derece", field: "derece", className: "text-center" },
        { header: "Tutari", field: "tutar", className: "text-center" },
    ];
    const [data, setData] = useState<any[]>([]);
    const [searchControl, setSearchControl] = useState<boolean>(true);
    const { yilListe } = useContext(ConstantAPISContext);
    const [selectedYear, setSelectedYear] = useState(Number(new Date().getFullYear()));
    const [selectedGrup, setSelectedGrup] = useState<any>(undefined);
    const [selectedDerece, setSelectedDerece] = useState<any>(undefined);

    const [isLoading, setisLoading] = useState<boolean>(false);

    //Cevre Temizlik Tarife API
    useEffect(() => {
        fetchData(false);
    }, [])


    const fetchData = async (isPass: boolean = true) => {
        if (selectedYear !== 0) {
            setisLoading(true);
            const response = await CevreTemizlikAPI.getCevreTemizlikVergisiTarifeleriListe(
                selectedYear,
                selectedGrup,
                selectedDerece
            );
            setData(response.data);
            setTimeout(() => {
                setisLoading(false);

            }, 100)
            setSearchControl(true)


        }
        else {
            setSearchControl(false)
            showToast("Lütfen Yılı Seçiniz", "error");
        }
    }

    const handleTemizle = () => {
        setSelectedYear(Number(new Date().getFullYear()));
        setSelectedGrup(undefined)
        setSelectedDerece(undefined)

    }

    //Formik constantları
    const initialValues = {
        //boş kalacak ihtiyaca göre kullanılabilir
    };
    return (
        <div className="px-1 px-md-2 px-lg-4 py-3 card   w-100">
            <div className="card-body p-0">
                <Formik
                    initialValues={initialValues}
                    onSubmit={() => { }}>
                    <Form id="kayit-form" className="d-flex w-100 mb-4">
                        <div className="d-flex flex-column flex-sm-row w-100 gap-3 ml-2 mr-2">
                            <div className="d-flex flex-column flex-sm-row gap-2 w-100">

                                <FormControl size="small"
                                    sx={{
                                        width: {
                                            xs: "100%",
                                            sm: "50%",
                                            md: "25%",
                                        },
                                        minWidth: 140
                                    }}>

                                    <InputLabel id="">Yıl</InputLabel>
                                    <Select
                                        sx={{
                                            backgroundColor: "white"
                                        }}
                                        labelId=""
                                        id=""
                                        name="yil"
                                        label="yil"
                                        error={selectedYear == undefined && searchControl == false ? true : false}

                                        value={selectedYear || ""}
                                        onChange={(e) => {
                                            setSelectedYear(Number(e.target.value || undefined));
                                        }}                                >
                                        {yilListe.map((item) => (
                                            <MenuItem
                                                key={item}
                                                value={item.yili}                                            >
                                                {item.yili}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>


                                <FormControl size="small"
                                    sx={{
                                        width: {
                                            xs: "100%",
                                            sm: "50%",
                                            md: "25%",
                                        },
                                        minWidth: 140
                                    }}>

                                    <InputLabel id="">Grup</InputLabel>
                                    <Select
                                        sx={{
                                            backgroundColor: "white"
                                        }}
                                        labelId=""
                                        id=""
                                        value={selectedGrup || ""}
                                        label="Grup"
                                        onChange={(e) => {
                                            setSelectedGrup(Number(e.target.value || undefined));
                                        }}                              >

                                        <MenuItem value={1}>{1}</MenuItem>
                                        <MenuItem value={2}>{2}</MenuItem>
                                        <MenuItem value={3}>{3}</MenuItem>
                                        <MenuItem value={4}>{4}</MenuItem>
                                        <MenuItem value={5}>{5}</MenuItem>
                                        <MenuItem value={6}>{6}</MenuItem>
                                        <MenuItem value={7}>{7}</MenuItem>

                                    </Select>
                                </FormControl>


                                <FormControl size="small"
                                    sx={{
                                        width: {
                                            xs: "100%",
                                            sm: "50%",
                                            md: "25%",
                                        },
                                        minWidth: 140
                                    }}>

                                    <InputLabel id="">Derece</InputLabel>
                                    <Select
                                        sx={{
                                            backgroundColor: "white"
                                        }}
                                        labelId=""
                                        id=""
                                        value={selectedDerece || ""}
                                        label="Grup"
                                        onChange={(e) => {
                                            setSelectedDerece(Number(e.target.value || undefined));
                                        }}                              >

                                        <MenuItem value={1}>{1}</MenuItem>
                                        <MenuItem value={2}>{2}</MenuItem>
                                        <MenuItem value={3}>{3}</MenuItem>
                                        <MenuItem value={4}>{4}</MenuItem>
                                        <MenuItem value={5}>{5}</MenuItem>

                                    </Select>
                                </FormControl>

                            </div>
                            <div className="d-flex  flex-row ms-auto ">
                                <SearchComponent
                                    fetchData={fetchData}
                                    onTemizle={handleTemizle}
                                    setData={setData} />
                            </div>
                        </div>
                    </Form>
                </Formik>
                {isLoading ?
                    <div className="d-flex w-100 justify-content-center align-items-center" style={{ height: '10rem' }}>

                        <CircularProgress />
                    </div>
                    :
                    <TableComponent columns={columns} data={data} recordsPerPage={12}></TableComponent>
                }
            </div>
        </div >
    )
}

export default CevreTemizlikTarifeleri;